import {ServiceClass} from '@/decorators';
import {AnyObject} from '@/globals';
import {LocationConnectionModel} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class LocationConnectionApi extends BaseApi {
    public createLocationConnection(fromLocationId: string, toLocationId: string) {
        const data = {
            fromLocationId,
            toLocationId,
        };
        return this.POST_RequestAsync<LocationConnectionModel>(`${this.ApiUrl}/location-connections`, data);
    }

    public getLocationConnectionByIdAsync(id: string, include: AnyObject[] = []) {
        const filter = include?.length ? {include} : {};
        return this.GET_RequestAsync<LocationConnectionModel>(`${this.ApiUrl}/location-connections/${id}?filter=${JSON.stringify(filter)}`);
    }

    public removeLocationConnection(id: string) {
        return this.DELETE_RequestAsync<void>(`${this.ApiUrl}/location-connections/${id}/remove`);
    }
}
